import { useLayoutEffect, useState } from 'react';
import { getElementDimensions } from './util';

export const useScrollPercentage = (viewport: HTMLDivElement | null) => {
  const [scrollPercentage, setScrollPercentage] = useState(0);

  // keep track of the scroll percentage of the viewport
  useLayoutEffect(() => {
    if (!viewport) return;
    let frameId: number;
    const updateScrollState = () => {
      const { scrollTop, scrollHeight } = viewport;
      const { height } = getElementDimensions(viewport);
      const scrollPercentage = scrollTop / (scrollHeight - height);
      setScrollPercentage(scrollPercentage);
      frameId = requestAnimationFrame(updateScrollState);
    };
    // start raf loop
    frameId = requestAnimationFrame(updateScrollState);
    return () => cancelAnimationFrame(frameId);
  }, [viewport]);

  return scrollPercentage;
};
